import usePrinterDeviceStatusHub from 'hooks/useHardwareAgent/Devices/usePrinterDeviceStatusHub'
import useCFDOnPOSHub from 'hooks/useHardwareAgent/CFD/useCFDOnPOSHub'
import { ReactNode, createContext, useContext } from 'react'
import usePosHub from 'websockets/usePosHub'
import useCallerIdHub from 'hooks/useHardwareAgent/CallerId/useCallerIdHub'

const PosHwAgentHubContextProvider = ({
    children,
}: {
    children: ReactNode
}) => {
    return (
        <PrinterContextProvider>
            <CallerIdHubContextProvider>
                <CFDContextProvider>{children}</CFDContextProvider>
            </CallerIdHubContextProvider>
        </PrinterContextProvider>
    )
}

type ICFDHubState = ReturnType<typeof useCFDOnPOSHub>
const CFdHubContext = createContext<ICFDHubState>({} as ICFDHubState)

const CFDContextProvider = ({ children }: { children: ReactNode }) => {
    const cfdOnPosHubHook = useCFDOnPOSHub()

    return (
        <CFdHubContext.Provider value={cfdOnPosHubHook}>
            {children}
        </CFdHubContext.Provider>
    )
}

type IPrinterHubState = ReturnType<typeof usePrinterDeviceStatusHub>
const PrinterHubContext = createContext<IPrinterHubState>(
    {} as IPrinterHubState,
)

const PosHubComponent = ({ children }: { children: ReactNode }) => {
    usePosHub()

    return <>{children}</>
}

const PrinterContextProvider = ({ children }: { children: ReactNode }) => {
    const value = usePrinterDeviceStatusHub()

    return (
        <PrinterHubContext.Provider value={value}>
            <PosHubComponent>{children}</PosHubComponent>
        </PrinterHubContext.Provider>
    )
}

type ICallerIdHubState = ReturnType<typeof useCallerIdHub>
const CallerIdHubContext = createContext<ICallerIdHubState>(
    {} as ICallerIdHubState,
)
const CallerIdHubContextProvider = ({ children }: { children: ReactNode }) => {
    const value = useCallerIdHub()

    return (
        <CallerIdHubContext.Provider value={value}>
            {children}
        </CallerIdHubContext.Provider>
    )
}

const usePOSCFDHubContext = () => useContext(CFdHubContext)
const usePrinterHubContext = () => useContext(PrinterHubContext)
const useCallerIdHubContext = () => useContext(CallerIdHubContext)

export {
    usePOSCFDHubContext,
    usePrinterHubContext,
    useCallerIdHubContext,
    PosHwAgentHubContextProvider,
}
